import { render } from "./OnzeNewSelectedMixed.vue?vue&type=template&id=bb78b65a"
import script from "./OnzeNewSelectedMixed.vue?vue&type=script&lang=js"
export * from "./OnzeNewSelectedMixed.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\Vind\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__